import axios from "axios";

class EditCharity {
  constructor() {
    this.searchCharityIcon = document.querySelector(".searchCharityIcon");

    this.events();
  }

  events() {
    // SEARCH FORM BY REG NUMBER ON MY-CHARITY PAGE
    if (document.querySelector(".update-charity-introduction")) {
      if (this.searchCharityIcon) {
        this.searchCharityIcon.addEventListener("click", () =>
          this.searchCharityByRegNumber()
        );
        document.addEventListener("keydown", (e) => {
          if (e.which == 13 || e.keyCode == 13) {
            this.searchCharityByRegNumber();
          }
        });
      }
    }

    if (document.querySelector(".yes-edit-charity")) {
      document
        .querySelector(".yes-edit-charity")
        .addEventListener("click", () => this.linkCharityToUser());
    }
  }

  async searchCharityByRegNumber() {
    try {
      document.querySelector(".result-spinner").style.display = "flex";
      let regNumberValue = document.querySelector(".searchCharityInput").value;

      const response = await axios.get(
        charitiesData.root_url +
          "/wp-json/charity/v1/charity-reg-number/?regNumber=" +
          regNumberValue
      );
      console.log(response);
      document.querySelector(".result-spinner").style.display = "none";

      const results = response.data;
      console.log(results.charity_name);
      if (!Array.isArray(results) && typeof results === "object") {
        document.querySelector(".result-search-my-charity").innerHTML = `
          <div class="container t-center content-area">
          <h3>Is this the charity you want to edit?</h3>
          <a href="${
            charitiesData.root_url +
            "/charity/" +
            results.charity_name.replace(/\s+/g, "-").toLowerCase() +
            "/" +
            results.reg_charity_number +
            "/"
          }" target="_blank"><h2 class="reg-number-charity-result" charity-id="${
          results.reg_charity_number
        }">${results.charity_name}</h2></a>
          </div>
          `;
        document.querySelector(".first-choice-my-charity").style.display =
          "flex";
      } else {
        //console.log(results);
        document.querySelector(".result-search-my-charity").innerHTML = `
          <div class="container t-center content-area">
          <h3>This charity is already linked to an account</h3>
          <a href="mailto: william@charitiesnearme.uk"><h3>If you think there is a mistake, click here to contact us</h3></a>
          </div>
          `;
      }
    } catch (e) {
      console.log(e);
    }
  }

  async linkCharityToUser() {
    try {
      const userID = document
        .querySelector(".first-choice-my-charity")
        .getAttribute("user-id");
      const charityID = document
        .querySelector(".reg-number-charity-result")
        .getAttribute("charity-id");
      const response = await axios.post(
        charitiesData.root_url +
          "/wp-json/charity/v1/register-charity-wp/?regNumber=" +
          charityID +
          "&userId=" +
          userID
      );
      const results = response.data;
      console.log(results);
      if (results) {
        window.location = charitiesData.root_url + "/edit-charity/";
      }
    } catch (e) {
      console.log(e);
    }
  }
}

export default EditCharity;
